import AppLabel from "./app-label";

const DraftLabel = ({ className = "" }: { className?: string }) => (
  <AppLabel label="draft" className={className} />
);

export default DraftLabel;
